<template>
  <div>
    <div class="h-10 p-2 text-base font-bold bg-dark-2 text-[#FFCC01] flex items-center gap-2">
      <ImgIcon
        :src="icon"
        size="24px"
      />
      인기리그
    </div>
    <div class="flex flex-col divide-y divide-dark-4 border border-dark-1">
      <RouterLink
        v-for="league in drawerStore.popularLeagues"
        :to="{name: 'pregames', params: {sport: league.sport_id, league: league.id}}"
        class="flex flex-nowrap divide-x divide-dark-4"
      >
        <div class="px-3 py-4 bg-dark-3">
          <SportIcon
            :sport-id="league.sport_id"
            size="18px"
          />
        </div>
        <div class=" w-full flex flex-nowrap items-center justify-between px-4 bg-dark-1">
          <div class="flex flex-nowrap items-center gap-2">
            <ImgIcon
              :src="league.icon"
              size="18px"
            />
            <div class="grid">
              <span class="truncate">{{ league.name_ko }}</span>
            </div>
          </div>
          ({{ league.game_count }})
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
import icon from '@/icons/drawer/league.svg'
import ImgIcon from '@/components/Icons/ImgIcon.vue'
import SportIcon from '@/components/Icons/SportIcon.vue'
import { useDrawerStore } from '@/stores/drawer'

const drawerStore = useDrawerStore()
</script>
